define(
({
	loadingState: "Încărcare...",
	errorState: "Ne pare rău, a apărut o eroare "
})
);
